"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importStar(require("react"));

var react_awesome_slider_1 = __importDefault(require("react-awesome-slider"));

require("react-awesome-slider/dist/custom-animations/scale-out-animation.css");

var utils_1 = require("../../utils");

var SideBar_1 = __importDefault(require("../SideBar"));

require("./style.scss");
/**
* Story component.
*/


var Story = function Story(_a) {
  var _b = _a.active,
      active = _b === void 0 ? 0 : _b,
      children = _a.children,
      description = _a.description,
      image = _a.image,
      label = _a.label,
      logo = _a.logo,
      onChange = _a.onChange,
      type = _a.type;

  var _c = (0, react_1.useState)(active),
      activeIndex = _c[0],
      setActiveIndex = _c[1];

  var classes = (0, utils_1.classList)('story-story', "story-story-" + type);

  var key = function key(index) {
    return "moment-" + index;
  };

  var moments = react_1.default.Children.map(children, function (moment, index) {
    return react_1.default.createElement("div", {
      className: "story-story__moments__moment-container",
      key: key(index)
    }, moment);
  });

  var handleMomentChange = function handleMomentChange(index) {
    if (onChange) {
      onChange(index);
    }

    setActiveIndex(index);
  };

  return react_1.default.createElement("div", {
    className: classes
  }, react_1.default.createElement(SideBar_1.default, {
    activeIndex: activeIndex,
    description: description,
    image: image,
    logo: logo,
    onSelect: handleMomentChange,
    title: label
  }, children), react_1.default.createElement("div", {
    className: "story-story__moments"
  }, react_1.default.createElement(react_awesome_slider_1.default, {
    animation: "scaleOutAnimation",
    bullets: false,
    buttons: false,
    organicArrows: false,
    selected: activeIndex
  }, moments)));
};

Story.propTypes = {
  /** Selected `Moment` Index of the `Story` */
  active: prop_types_1.default.number,

  /** List of `Moment`s to render of the `Story` */
  children: prop_types_1.default.arrayOf(prop_types_1.default.element).isRequired,

  /** The main description of the `Story` */
  description: prop_types_1.default.string,

  /** Image URL source */
  image: prop_types_1.default.string,

  /** Main name of the `Story` */
  label: prop_types_1.default.string.isRequired,

  /** Specify the type of `Story` */
  type: prop_types_1.default.string
};
Story.defaultProps = {
  active: 0,
  description: undefined,
  image: undefined,
  type: 'base'
};
exports.default = Story;